import React, { useContext } from 'react'
import { AuthContext } from "../../Auth"

const PrivateComponent = ({roles=[], children={}}) => {
    const { currentUser } = useContext(AuthContext)
    return (
        <>
            {
                !!currentUser &&
                (roles.includes(currentUser.rol) || currentUser.rol === 'admin' || currentUser.email === "admin@admin.com")
                ?
                    children
                :
                    null
            }
        </>
    )

}

export {PrivateComponent}